// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2P5xd","modalControls":"_13Zmr","deleteBtnWrapper":"_1QSV0"};